import CrudCustom from '../../../libs/custom/CrudCustom';

let ElemenTranskripService = new CrudCustom('/tipe-transkrips');
export default ElemenTranskripService;
